export function getSize(scrollbar) {
  var containerEl = scrollbar.containerEl,
      contentEl = scrollbar.contentEl;
  return {
    container: {
      // requires `overflow: hidden`
      width: containerEl.clientWidth,
      height: containerEl.clientHeight
    },
    content: {
      // border width should be included
      width: contentEl.offsetWidth - contentEl.clientWidth + contentEl.scrollWidth,
      height: contentEl.offsetHeight - contentEl.clientHeight + contentEl.scrollHeight
    }
  };
}